<template>
  <table class="tableSize flipTable">
    <tr>
      <th class="tableHeader" v-for="(head, n) in header" :key="n">
        {{head}}
      </th>
    </tr>
    <tbody>
      <tr v-for="(data, index) in viewData" v-if="showData(data.ad_knd_nm)" :key="index">
        <td class="sortCenter">
          {{data.ad_knd_nm}}
        </td>
        <td class="sortCenter">
          {{data.size_nm}}
        </td>
        <td class="sortRight">
          <div class="data_wrap">
            {{parseDataType(data.imp_cnt)}}
          </div>
        </td>
        <td class="sortRight">
          <div class="data_wrap">
            {{parseDataType(data.click_cnt)}}
          </div>
        </td>
        <td class="sortRight">
          <div class="data_wrap">
            {{data.ctr.toFixed(2)}}
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
  import { parseDataType } from '@/assets/func'

  export default {
    name: 'sizeTable',
    props: {
      viewData: Array,
      checkRadio: String
    },
    data () {
      return {
        header: [
          '광고상품',
          '사이즈',
          '노출수',
          '클릭수',
          'CTR(%)'
        ]
      }
    },
    methods: {
      parseDataType (data) {
        return parseDataType(data)
      },
      showData (name) {
        if (this.checkRadio === 'all') return true
        return name === this.checkRadio
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SizeTable.vue?493edba1